import React from 'react';
import './header.css';
import LOGO from "../../img/foco.svg";

const Header = () => {
    return (
        <div className="header">
          <div className="header--inner">
            <span className="header--logo">
              <img src={LOGO} />
              <p className="">Sistema administrativo</p>
            </span>
          </div>
        </div>
    );
}

export default Header;



// WEBPACK FOOTER //
// ./src/classes/header/Header.js